export function setRemoveMaskMoney(value: string): number {
    let remove = value;
    let firstValue = 0;
    let secondValue = 0;
    remove = value.replace(/\./g, "").replace(/,/g, "");
    firstValue = Number(remove);
    secondValue = firstValue / 100;
    return secondValue;
}
